export const API_BASE_URL = 'https://your-api-url.com/'
export const DSN_SENTRY = 'https://185b7f8b9137ea30aa14c5f99d2b146d@o4506020256743424.ingest.sentry.io/4506183218036736'